import * as React from 'react';
import {CSSProperties} from 'react';
import * as Tgcc from '../tgccGlobal';
import {connect} from 'react-redux';
import Radium, { StyleRoot } from 'radium';
import { Carousel } from 'react-bootstrap';

const imgStyle: CSSProperties = {
    height:'500px',
    marginRight:'5%'
}
const slideDiv: CSSProperties = {
    width:'100%',
    display:'flex',
    overflowY:'hidden'
}
const realCamphdr: CSSProperties = {
    display:'flex',
    flexDirection:'column',
    justifyContent:'center',
    alignItems:'center',
    marginTop:'5%',
    marginBottom:'1%'
}
const realHdr: CSSProperties = {
    color:'#748092',
    fontFamily:'Lulo',
    fontSize:'46px',
    textAlign:'center'
}
const realSub: CSSProperties = {
    fontFamily:'BarlowLight',
    color:'#748092'
}
class _RealCampusSlider extends React.Component<Tgcc.BaseProps,any> {

    render(){
        return (
            <div>
                <div style={realCamphdr}>
                    <div style={realHdr}>#REAL CAMPUS</div>
                    <div style={realSub}>See what other schools & organizations are doing with Real Campus now!</div>
                </div>
                <div style={slideDiv}>
                            <img style={imgStyle} src={Tgcc.ResolveUrl('~/images/RealCampusImg/623594-01.png')} />
                            <img style={imgStyle} src={Tgcc.ResolveUrl('~/images/RealCampusImg/629662-01.png')} />
                            <img style={imgStyle} src={Tgcc.ResolveUrl('~/images/RealCampusImg/633415-01.png')} />
                            <img style={imgStyle} src={Tgcc.ResolveUrl('~/images/RealCampusImg/640165-01.png')} />
                            <img style={imgStyle} src={Tgcc.ResolveUrl('~/images/RealCampusImg/641651-01.png')} />
                            <img style={imgStyle} src={Tgcc.ResolveUrl('~/images/RealCampusImg/642460-01.png')} />
                            <img style={imgStyle} src={Tgcc.ResolveUrl('~/images/RealCampusImg/643586-01.png')} />
                </div>   
            </div>
        )
    }
}

const mapStateToProps = (state:Tgcc.GlobalState,ownState:any) => {
    return {state:state}
}

export var RealCampusSlider = connect(mapStateToProps)(Radium(_RealCampusSlider));